var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_3325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 7.96553C9.15556 7.60997 9.40278 7.20442 9.575 6.74886C9.74722 6.2933 9.83333 5.82108 9.83333 5.33219C9.83333 4.8433 9.74722 4.37108 9.575 3.91553C9.40278 3.45997 9.15556 3.05442 8.83333 2.69886C9.5 2.78775 10.0556 3.08219 10.5 3.58219C10.9444 4.08219 11.1667 4.66553 11.1667 5.33219C11.1667 5.99886 10.9444 6.58219 10.5 7.08219C10.0556 7.58219 9.5 7.87664 8.83333 7.96553ZM12.5 13.3322V11.3322C12.5 10.9322 12.4111 10.5516 12.2333 10.1905C12.0556 9.82942 11.8222 9.50997 11.5333 9.23219C12.1 9.43219 12.625 9.69053 13.1083 10.0072C13.5917 10.3239 13.8333 10.7655 13.8333 11.3322V13.3322H12.5ZM13.8333 8.66553V7.33219H12.5V5.99886H13.8333V4.66553H15.1667V5.99886H16.5V7.33219H15.1667V8.66553H13.8333ZM5.83333 7.99886C5.1 7.99886 4.47222 7.73775 3.95 7.21553C3.42778 6.69331 3.16667 6.06553 3.16667 5.33219C3.16667 4.59886 3.42778 3.97108 3.95 3.44886C4.47222 2.92664 5.1 2.66553 5.83333 2.66553C6.56667 2.66553 7.19444 2.92664 7.71667 3.44886C8.23889 3.97108 8.5 4.59886 8.5 5.33219C8.5 6.06553 8.23889 6.69331 7.71667 7.21553C7.19444 7.73775 6.56667 7.99886 5.83333 7.99886ZM0.5 13.3322V11.4655C0.5 11.0877 0.597222 10.7405 0.791667 10.4239C0.986111 10.1072 1.24444 9.86553 1.56667 9.69886C2.25556 9.35442 2.95556 9.09608 3.66667 8.92386C4.37778 8.75164 5.1 8.66553 5.83333 8.66553C6.56667 8.66553 7.28889 8.75164 8 8.92386C8.71111 9.09608 9.41111 9.35442 10.1 9.69886C10.4222 9.86553 10.6806 10.1072 10.875 10.4239C11.0694 10.7405 11.1667 11.0877 11.1667 11.4655V13.3322H0.5Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_3325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.3f1f581f714d593545f59571b6b6ee35.svg";
export { ForwardRef as ReactComponent };